module.exports = __webpack_public_path__ + "img/11.9b1503e1.png";